import React from 'react'

import Icon from '@mdi/react'
import { mdiFilterOutline } from '@mdi/js'

import { IconButton } from '@mui/material'
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined'
import HighlightOffOutlinedIcon from '@mui/icons-material/HighlightOffOutlined'
import KeyboardDoubleArrowLeftOutlinedIcon from '@mui/icons-material/KeyboardDoubleArrowLeftOutlined'
import KeyboardDoubleArrowRightOutlinedIcon from '@mui/icons-material/KeyboardDoubleArrowRightOutlined'

import { Checkbox, Drawer, Input, InputGroup, Loader } from 'rsuite'

import css from './accessLevelPortfolio.module.scss'
import { BootstrapTooltip } from '../../../../_ui/tooltip'
import Empty from '../../../../_ui/empty'
import emptyDoc from './../../../../../img/empty_documents.svg'

const AccessLevelPortfolio = (props: any) => {
    return (
        <Drawer autoFocus={false} size="full" open={props.getAccessLevelPortfolioStudentVisible} onClose={() => props.onClickCloseEditAccessLevel()}>
            <div className={css.main}>
                <div className={css.mainHeader}>
                    <div className={css.headerTitle}>Редактирование уровней доступа портфолио студента</div>

                    <div className={css.headerBar}>
                        <BootstrapTooltip title="Закрыть" placement="bottom" arrow>
                            <IconButton size="medium" sx={{ color: "#5763b3", m: "auto 0" }} onClick={() => props.onClickCloseEditAccessLevel()}>
                                <CloseOutlinedIcon />
                            </IconButton>
                        </BootstrapTooltip>
                    </div>
                </div>

                <div className={css.mainBody}>
                    <UnassignedGroupsList {...props} />
                    
                    <div className={css.bodyButtonPanel}>
                        <BootstrapTooltip title="Добавить в назначенные группы" placement="top" arrow>
                            <span>
                                <IconButton size="large" sx={{ color: "#151321", m: "auto 0" }}
                                    onClick={props.onClickMoveUnassignedGroups}
                                    disabled={props.checkedAllUnassignedGroupsCount !== 0 ? false : true}>
                                    <KeyboardDoubleArrowRightOutlinedIcon />
                                </IconButton>
                            </span>
                        </BootstrapTooltip>

                        <BootstrapTooltip title="Удалить из назначенных групп" placement="bottom" arrow>
                            <span>
                                <IconButton size="large" sx={{ color: "#151321", m: "auto 0" }}
                                    onClick={props.onClickMoveAssignedGroups}
                                    disabled={props.checkedAllAssignedGroupsCount !== 0 ? false : true}>
                                    <KeyboardDoubleArrowLeftOutlinedIcon />
                                </IconButton>
                            </span>
                        </BootstrapTooltip>
                    </div>

                    <AssignedGroupsList {...props} />
                </div>
            </div>
        </Drawer>
    )
}

// Не распределенные группы
const UnassignedGroupsList = (props: any) => {
    return (
        <div className={css.bodyContent}>
            <div className={css.contentHead}>
                <BootstrapTooltip title="Выбрать всё" placement="top" arrow>
                    <div>
                        <Checkbox
                            indeterminate={props.checkedAllUnassignedGroupsCount > 0 && props.checkedAllUnassignedGroupsCount !== props.unassignedGroupsList.length}
                            checked={props.unassignedGroupsList.length ? props.checkedAllUnassignedGroupsCount === props.unassignedGroupsList.length : false}
                            disabled={props.unassignedGroupsList.length ? false : true}
                            onChange={(value, checked) => props.onChangeSelectedAllUnassignedGroups(checked)}
                        />
                    </div>
                </BootstrapTooltip>

                <div className={css.headTitle}>Не назначенные группы ({props.unassignedGroupsList.length})</div>

                <InputGroup inside style={{ width: "200px" }} disabled={props.unassignedGroupsList.length ? false : true}>
                    <InputGroup.Addon>
                        <Icon path={mdiFilterOutline} size={1} style={{ margin: "-4px 0 0 -6px" }} />
                    </InputGroup.Addon>

                    <Input type="text" size="md" placeholder="Фильтр..."
                        autoComplete="off" style={{ paddingRight: "40px" }}
                        value={props.getFilterUnassignedGroups}
                        onChange={value => props.setFilterUnassignedGroups(value)}
                    />

                    {props.getFilterUnassignedGroups &&
                        <InputGroup.Addon onClick={() => props.setFilterUnassignedGroups('')} style={{ margin: "-7px -7px 0 0" }}>
                            <BootstrapTooltip title="Очистить" placement="bottom" arrow>
                                <IconButton size="small" sx={{ color: "#5763b3", m: "auto 0" }}>
                                    <HighlightOffOutlinedIcon sx={{ fontSize: 18 }} />
                                </IconButton>
                            </BootstrapTooltip>
                        </InputGroup.Addon>
                    }
                </InputGroup>
            </div>

            <div className={css.itemsBody}>
                <div className={css.itemsContent}>
                    {props.isVisibleLoaderLevelsOperator 
                        ? <div style={{ height: "100%", position: "relative" }}><Loader center size="md" content="Загрузка данных..." vertical /></div>
                        : !props.unassignedGroupsList.length
                            ? <Empty image={emptyDoc} description="Данные отсутствуют" heightBox="200px" heightImg="150px" />
                            : props.unassignedGroupsList.filter((val: any) => {
                                let stringReturn

                                let groupName = val.groupName.toLowerCase().includes(props.getFilterUnassignedGroups.toLowerCase())

                                if (groupName) {
                                    stringReturn = val
                                }

                                return stringReturn
                            }).map((unassigned: any) => {
                                return (
                                    <div key={unassigned.groupName} className={css.levelItem}>
                                        <Checkbox
                                            value={unassigned.groupName}
                                            checked={unassigned.isSelected}
                                            onChange={(value, checked) => props.onChangeUnassignedGroups(value, checked)}
                                        >{unassigned.groupName}</Checkbox>
                                    </div>
                                )
                            })
                    }
                </div>
            </div>
        </div>
    )
}

// Распределенные группы
const AssignedGroupsList = (props: any) => {
    return (
        <div className={css.bodyContent}>
            <div className={css.contentHead}>
                <BootstrapTooltip title="Выбрать всё" placement="top" arrow>
                    <div>
                        <Checkbox
                            indeterminate={props.checkedAllAssignedGroupsCount > 0 && props.checkedAllAssignedGroupsCount !== props.assignedGroupsList.length}
                            checked={props.assignedGroupsList.length ? props.checkedAllAssignedGroupsCount === props.assignedGroupsList.length : false}
                            disabled={props.assignedGroupsList.length ? false : true}
                            onChange={(value, checked) => props.onChangeSelectedAllAssignedGroups(checked)}
                        />
                    </div>
                </BootstrapTooltip>
                
                <div className={css.headTitle}>Назначенные группы ({props.assignedGroupsList.length})</div>
                
                <InputGroup inside style={{ width: "200px" }} disabled={props.assignedGroupsList.length ? false : true}>
                    <InputGroup.Addon>
                        <Icon path={mdiFilterOutline} size={1} style={{ margin: "-4px 0 0 -6px" }} />
                    </InputGroup.Addon>

                    <Input type="text" size="md" placeholder="Фильтр..."
                        autoComplete="off" style={{ paddingRight: "40px" }}
                        value={props.getFilterAssignedGroups}
                        onChange={value => props.setFilterAssignedGroups(value)}
                    />

                    {props.getFilterAssignedGroups &&
                        <InputGroup.Addon onClick={() => props.setFilterAssignedGroups('')} style={{ margin: "-7px -7px 0 0" }}>
                            <BootstrapTooltip title="Очистить" placement="bottom" arrow>
                                <IconButton size="small" sx={{ color: "#5763b3", m: "auto 0" }}>
                                    <HighlightOffOutlinedIcon sx={{ fontSize: 18 }} />
                                </IconButton>
                            </BootstrapTooltip>
                        </InputGroup.Addon>
                    }
                </InputGroup>
            </div>

            <div className={css.itemsBody}>
                <div className={css.itemsContent}>
                    {props.isVisibleLoaderLevelsOperator
                        ? <div style={{ height: "100%", position: "relative" }}><Loader center size="md" content="Загрузка данных..." vertical /></div>
                        : !props.assignedGroupsList.length
                            ? <Empty image={emptyDoc} description="Данные отсутствуют" heightBox="200px" heightImg="150px" />
                            : props.assignedGroupsList.filter((val: any) => {
                                let stringReturn

                                let groupName = val.groupName.toLowerCase().includes(props.getFilterAssignedGroups.toLowerCase())

                                if (groupName) {
                                    stringReturn = val
                                }

                                return stringReturn
                            }).map((assigned: any) => {
                                return (
                                    <div key={assigned.groupName} className={css.levelItem}>
                                        <Checkbox
                                            value={assigned.groupName}
                                            checked={assigned.isSelected}
                                            onChange={(value, checked) => props.onChangeAssignedGroups(value, checked)}
                                        >{assigned.groupName}</Checkbox>
                                    </div>
                                )
                            })
                    }
                </div>
            </div>
        </div>
    )
}

export default AccessLevelPortfolio